import { render, staticRenderFns } from "./ActualitiesBanner.vue?vue&type=template&id=1015d814&scoped=true"
import script from "./ActualitiesBanner.vue?vue&type=script&lang=js"
export * from "./ActualitiesBanner.vue?vue&type=script&lang=js"
import style0 from "./ActualitiesBanner.vue?vue&type=style&index=0&id=1015d814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015d814",
  null
  
)

export default component.exports